import { render, staticRenderFns } from "./OrdersFavorites.vue?vue&type=template&id=d98deddc"
import script from "./OrdersFavorites.vue?vue&type=script&lang=js"
export * from "./OrdersFavorites.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports